var React = require('react');

function SquarePlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.6 22H21.4C21.73 22 22 21.73 22 21.4V2.6C22 2.27 21.73 2 21.4 2H2.6C2.27 2 2 2.27 2 2.6V21.4C2 21.73 2.27 22 2.6 22ZM20.8 20.8H3.2V3.2H20.8V20.8ZM13.6 5.75H10.4C10.07 5.75 9.80005 6.02 9.80005 6.35V9.80005H6.35C6.02 9.80005 5.75 10.07 5.75 10.4V13.6C5.75 13.93 6.02 14.2 6.35 14.2H9.80005V17.65C9.80005 17.98 10.07 18.25 10.4 18.25H13.6C13.93 18.25 14.2 17.98 14.2 17.65V14.2H17.65C17.98 14.2 18.25 13.93 18.25 13.6V10.4C18.25 10.07 17.98 9.80005 17.65 9.80005H14.2V6.35C14.2 6.02 13.93 5.75 13.6 5.75Z"}));
}

SquarePlus.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = SquarePlus;

SquarePlus.default = SquarePlus;
